import { render, staticRenderFns } from "./GalleriesPage.vue?vue&type=template&id=856b7c50&scoped=true"
import script from "./GalleriesPage.vue?vue&type=script&lang=js"
export * from "./GalleriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b7c50",
  null
  
)

export default component.exports